import { ReactNode } from 'react'

interface SettingsRowProps {
  title: string | ReactNode
  description?: string
  action: ReactNode
  className?: string
  noStack?: boolean
}

export const SettingsRow = ({ title, description, action, className = '', noStack = false }: SettingsRowProps) => {
  const layoutClasses = noStack 
    ? 'flex items-center justify-between gap-4' 
    : 'flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4'
  
  return (
    <div className={`${layoutClasses} ${className}`}>
      <div className={`min-w-0 flex-1 ${noStack ? 'mr-4' : 'sm:mr-4'}`}>
        {typeof title === 'string' ? (
          <p className="text-sm font-medium">{title}</p>
        ) : (
          title
        )}
        {description && <p className="text-muted-foreground text-xs">{description}</p>}
      </div>
      <div className={noStack ? '' : 'w-full sm:w-auto'}>{action}</div>
    </div>
  )
}
